import { useContext, useEffect } from "react";
import logo from "../../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import background from "../../assets/images/background.png";
import title from "../../assets/images/title.png";
import { VersionContext } from "../../context";
import { PointUtil } from "../../utils/point/PointUtil";
import DownloadComponent from "../../components/DownloadComponent";
import { getPlatform } from "../../utils";
import "./index.css";

const Ios = () => {
  const { appVersionData } = useContext(VersionContext);
  const info = appVersionData?.iosVersionInfo;
  const navigate = useNavigate();
  const platform = getPlatform();

  useEffect(() => {
    PointUtil.pointEvent("show", "10.9.9.5");
  }, []);

  // 安卓 || ios没有版本 跳首页

  useEffect(() => {
    setTimeout(() => {
      info && window.location.replace(info?.packageUrl);
      if (!info || platform === "Android") {
        navigate("/");
      }
    }, 100);
  }, [info]);

  const imgArr = [1, 2, 3, 4];

  return (
    <div className="iosPage">
    {/*<img className="backgroundIcon" src={background} alt="background" />*/}
      <div className="iosPageContainer">
        <div className="iosPageheader">
          <p>
            <img className="ioslogo" src={logo} alt="logo" />
          </p>
          <img className="titleImg" src={title} alt="title" />
          {info?.packageUrl && (
            <DownloadComponent
              downloadUrl={info?.packageUrl || ""}
              // downloadUrl={"https://itunes.apple.com/cn/app/id1412534170"}
              fileName={info?.packageName || ""}
            />
          )}
          {/* <div className="btn" onClick={download}>{btnText}</div> */}
        </div>
        <p className="textSize" style={{ marginTop: 20 }}>版本号：V{info?.appVersionNo}</p>
        {/* {imgArr.map((i, index) => {
          return (
            <div key={`ios-${index}`} className="iosPageContainerWrap">
              <img
                alt="container"
                className="iosPageContainerImg"
                src={require(`../../assets/images/ios/ios${i}.png`)}
              />
            </div>
          );
        })} */}
      </div>
      <p className="iosText textSize bottom">开发者：深圳灵感之茶科技有限公司</p>

    </div>
  );
};

export default Ios;
